
import React from 'react';
import { Sparkles, GraduationCap, Clock, Wallet, CheckCircle, ArrowRight, Video, MessageCircle } from 'lucide-react';

interface LiveTeachingProps {
  onBook: () => void;
}

const LiveTeaching: React.FC<LiveTeachingProps> = ({ onBook }) => {
  return (
    <section className="py-24 bg-slate-950 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_30%,_rgba(245,158,11,0.05)_0%,_transparent_50%)]" />
      
      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="bg-gradient-to-br from-slate-900 to-indigo-950 border-2 border-amber-500/30 p-8 md:p-16 rounded-sm shadow-2xl relative overflow-hidden group">
          <div className="absolute top-0 right-0 p-8 opacity-5 group-hover:opacity-10 transition-opacity">
            <GraduationCap size={200} className="text-amber-500" />
          </div>

          <div className="grid lg:grid-cols-12 gap-12 items-center">
             <div className="lg:col-span-7 space-y-8">
                <div>
                   <div className="inline-flex items-center gap-2 px-3 py-1 bg-amber-500 text-slate-950 text-[10px] uppercase font-bold tracking-widest rounded-sm mb-6">
                      <Sparkles size={12}/> Premium Mastery
                   </div>
                   <h2 className="text-4xl md:text-6xl font-serif text-white leading-tight">Live Astrology Teaching & Q&A</h2>
                   <p className="text-xl text-indigo-200/80 font-light italic mt-4">"Become the master of your own sky. A dedicated, intensive alignment for true seekers."</p>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                   {[
                     "180 Minute Intensive Live Session",
                     "Free-for-all Celestial Q&A",
                     "Personalized Technical Instruction",
                     "Session Recorded for Your Vault",
                     "High-Resolution Chart Visuals",
                     "Direct mentorship from Allie"
                   ].map((feature, i) => (
                     <div key={i} className="flex items-center gap-3 text-indigo-100/70 text-sm uppercase tracking-wider font-bold">
                        <CheckCircle size={16} className="text-amber-500 shrink-0" />
                        {feature}
                     </div>
                   ))}
                </div>
             </div>

             <div className="lg:col-span-5">
                <div className="bg-slate-950/80 backdrop-blur-md border border-amber-500/20 p-10 rounded-sm text-center shadow-2xl">
                   <div className="flex justify-center gap-8 mb-8">
                      <div className="text-center">
                         <p className="text-[10px] uppercase text-indigo-500 font-bold mb-1">Duration</p>
                         <div className="flex items-center gap-2 text-white font-serif text-2xl">
                            <Clock size={20} className="text-amber-500"/> 180m
                         </div>
                      </div>
                      <div className="w-px h-10 bg-indigo-900/50" />
                      <div className="text-center">
                         <p className="text-[10px] uppercase text-indigo-500 font-bold mb-1">Investment</p>
                         <div className="flex items-center gap-2 text-white font-serif text-2xl">
                            <Wallet size={20} className="text-amber-500"/> $950
                         </div>
                      </div>
                   </div>

                   <div className="space-y-4 mb-8 text-sm text-indigo-200/60 leading-relaxed font-light italic">
                      "This is a high-stakes alignment designed for those who wish to read the stars themselves. Bring your deepest technical questions."
                   </div>

                   <button 
                     onClick={onBook}
                     className="w-full py-5 bg-amber-500 hover:bg-amber-400 text-slate-950 font-bold uppercase tracking-[0.3em] text-xs transition-all shadow-xl rounded-sm flex items-center justify-center gap-3"
                   >
                     Initiate Mastery <ArrowRight size={16}/>
                   </button>
                   
                   <p className="text-[8px] uppercase tracking-widest text-indigo-600 mt-4">Conducting via Secure Video/Audio Link</p>
                </div>
             </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LiveTeaching;
